export default __webpack_public_path__ + "src/docs/packages/the-coconut-shell.pdf";